import type { ScreenMonitor } from '@viewer/protocol';
import { INSIDE_APP } from '../../lib/config';
import { monitorWindowClose } from '../../lib/tauri/commands';

/** Altura da barra no topo da janela de um monitor desacoplado. */
const WINDOW_BAR_HEIGHT = 41;

/** O Host manda o principal primeiro, então ele é sempre o "Monitor 1". */
export function monitorLabel(index: number, monitor: ScreenMonitor): string {
  return `Monitor ${index + 1}${monitor.primary ? ' (principal)' : ''}`;
}

/**
 * Abre uma janela em branco para um monitor desacoplado, com os estilos desta página.
 * Ela continua ligada a esta (mesmo contexto), que desenha o conteúdo com um portal.
 * Precisa ser chamada no clique: fora dele o navegador bloqueia a janela.
 */
export function openMonitorWindow(title: string, monitor: ScreenMonitor): Window | null {
  const aspect = monitor.width / monitor.height;
  const width = Math.round(Math.min(screen.availWidth * 0.6, screen.availHeight * 0.6 * aspect));
  const height = Math.round(width / aspect) + WINDOW_BAR_HEIGHT;
  const popup = window.open('', '', `width=${width},height=${height}`);
  if (!popup) return null;

  popup.document.documentElement.lang = document.documentElement.lang;
  popup.document.title = title;
  const style = popup.document.createElement('style');
  style.textContent = Array.from(document.styleSheets, (sheet) =>
    Array.from(sheet.cssRules, (rule) => rule.cssText).join('\n'),
  ).join('\n');
  popup.document.head.append(style);
  return popup;
}

/** No app, `popup.close()` derruba só o conteúdo: quem fecha a janela de verdade é o Tauri. */
export function closeMonitorWindow(popup: Window) {
  if (popup.closed) return;
  if (INSIDE_APP) {
    void monitorWindowClose(popup.document.title).catch(() => popup.close());
  } else {
    popup.close();
  }
}
